<template>

    <div class="animate-on-scroll-panel">

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Animate on Scroll</h2>

        <div class="animate-onscroll-instructions-box">
            <p class="biggertext">Set specifications in left settings bar.</p>
            <b-alert show>
                <p>Activating this element will show a content area box in your Weebly editor where elements can be added to.</p>
                <p>View <a href="https://codepen.io/Rickable/full/EJYQKz" target="_blank">playground</a> to test the available settings.</p>
            </b-alert>
        </div>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <div class="bundle-animation-on-scroll-block" 
                :data-aos="settingsFromWeebly.settings.animationName"
                :data-aos-duration="settingsFromWeebly.settings.animationDuration"
                :data-aos-anchor-placement="settingsFromWeebly.settings.animationAnchor"
                :data-aos-delay="settingsFromWeebly.settings.animationDelay"
                data-aos-easing="ease-out"
                >
                <div class="only-weebly-editor">
                    <div class="animation-editor-text">
                        Animate On Scroll: effect for live site.
                    </div>
                </div>
                {content-animations-{{globalSettings.elementIdWeebly}}:content}
            </div>

        </div>

        <!-- <div class="animation-scroll-box">
            <h3 class="text-center main-sub-title">scroll down</h3>
            <h2 class="text-center main-title">Animation preview</h2>
            <div style="height:400px;"></div>
            <div class="animation-preview-box"
            :data-aos="settingsFromWeebly.settings.animationName"
                :data-aos-duration="settingsFromWeebly.settings.animationDuration"
                :data-aos-anchor-placement="settingsFromWeebly.settings.animationAnchor"
                :data-aos-delay="settingsFromWeebly.settings.animationDelay"
                data-aos-easing="ease-out">
                <h2>Preview Box</h2>
                <span>Animation Name:</span> {{settingsFromWeebly.settings.animationName}}<br>
                <span>Animation Duration:</span> {{settingsFromWeebly.settings.animationDuration}}<br>
                <span>Animation Anchor:</span> {{settingsFromWeebly.settings.animationAnchor}}<br>
                <span>Animation Delay:</span> {{settingsFromWeebly.settings.animationDelay}}
            </div>
            <div style="height:400px;"></div>
        </div> -->

    </div>

</template>

<script>

export default {

    name: 'AnimateOnScroll',

    data () {

        return {

        }
    },

    components: {

    },

    methods: {
        
    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        }

    },
    
    mounted() {
        console.log('from Anchor', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')

        // aos
        AOS.init();


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';
.preview-box  {
    .bundle-animation-on-scroll-block {
        display: none;
    }
}

.animation-scroll-box {
    text-align: center;
    margin: 20px auto;
    padding: 30px;
    background: #fff;
    border-radius: .25rem;
}

.animation-preview-box {
    h2 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 15px;
    }
    width: 300px;
    display: inline-block;
    padding: 30px 15px;
    border-radius: .25rem;
    font-size: 14px;
    background: @action_blue;
    color: #fff;
    span {
        font-weight: 700;
    }
}
.animate-on-scroll-panel .preview-box {
    height: 0;
    overflow: hidden;
    min-height: 0;
    padding: 0;
}
.animate-onscroll-instructions-box {
    background: #fff;
    padding: 75px 15px;
    border-radius: .25rem;
    text-align: center;
    .biggertext {
        font-size: 17px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/AnimateOnScroll.vue